import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as authService from '../../services/auth';
import actions from './actions';
import { history } from '../../index';
import toastr from 'toastr';
import { ROLE_ADMIN } from 'src/services/authorization/const';

export function* login({ payload }) {
  const { email, password } = payload;

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(authService.login, email, password);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'auth/SET_STATE',
      payload: {
        user: data.data.user,
        roles: data.data.roles,
        originalRoles: data.data.roles,
        country: data.data.country,
        counties: data.data.counties,
        sports: data.data.sports,
        authorized: true,
      }
    });

    toastr.success(data.message, '',{ positionClass: "toast-bottom-right", tapToDismiss: true });

    yield history.push('/dashboard');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'auth/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }

    toastr.error(response.data.message, '',{ positionClass: "toast-bottom-right", tapToDismiss: true });
  }

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* logout() {
  yield call(authService.logout);

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      user: {},
      authorized: false,
      loadingDetails: false,
    },
  })
}

export function* forgotPassword({ payload }) {
  const { email } = payload;

  const response = yield call(authService.forgotPassword, email);

  if (response && response.status === 200) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    yield history.push('/auth/login');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'auth/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* resetPassword({ payload }) {
  const { token, password, password_confirmation } = payload;

  const response = yield call(authService.resetPassword, token, password, password_confirmation);

  if (response && response.status === 200) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    yield history.push('/auth/login');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'auth/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* fetchWho() {
  yield put({
    type: 'auth/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(authService.fetchWho);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'auth/SET_STATE',
      payload: {
        user: data.data.user,
        roles: data.data.roles,
        originalRoles: data.data.roles,
        country: data.data.country,
        counties: data.data.counties,
        sports: data.data.sports,
        authorized: true,
        isUserLoaded: true
      },
    })
  }

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      loadingDetails: false
    },
  })
}

export function* refreshErrors() {
  yield put({
    type: 'auth/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export function* loginAsAdmin({ payload }) {
  const { country } = payload;

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      roles: [ROLE_ADMIN],
      country: country,
      loggedInAsAdmin: true
    },
  })
}

export function* loginAsSuperAdmin({ payload }) {
  const { roles } = payload;

  yield put({
    type: 'auth/SET_STATE',
    payload: {
      roles: roles,
      country: null,
      loggedInAsAdmin: false
    },
  })

  yield history.push('/dashboard');
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_WHO, fetchWho),
    takeEvery(actions.LOGIN, login),
    takeEvery(actions.LOGOUT, logout),
    takeEvery(actions.FORGOT_PASSWORD, forgotPassword),
    takeEvery(actions.RESET_PASSWORD, resetPassword),
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
    takeEvery(actions.LOGIN_AS_ADMIN, loginAsAdmin),
    takeEvery(actions.LOGIN_AS_SUPER_ADMIN, loginAsSuperAdmin),
    fetchWho()
  ])
}
